export default __webpack_public_path__ + "f0fe2c5b780a8db6b6a14a4816f0fa24.svg";